import { Bubble } from 'domain/bubble';

export const DEFAULT_BUBBLE: Bubble = {
  text: '',
  border: 0,
  person: 0,
  background: 0,
  options: [''],
};

export const PADDING = 10;
export const GAP = 10;
export const INTERVAL = 66;
export const NAME_TEXT_SIZE = 18;
